import { ClaimStatusDTO } from '@reposit/api-client';
import moment from 'moment';
import React, { FC } from 'react';
import IdentifierValue from '../IdentifierValue';
import RepositCard from '../Reposit/RepositCard';
import { Table, Tbody, Td, Thead, Tr } from '../Table';

interface ClaimStatuses {
  statuses: ClaimStatusDTO[];
}

export const ClaimStatuses: FC<ClaimStatuses> = ({ statuses }) => {
  return (
    <RepositCard flush title="Claim Statuses" tooltip="lorem">
      <Table>
        <Thead>
          <Tr>
            <Td>ID</Td>
            <Td>Status</Td>
            <Td>Created At</Td>
          </Tr>
        </Thead>
        <Tbody>
          {statuses &&
            statuses.length > 0 &&
            statuses.map((status) => (
              <Tr key={status.id}>
                <Td>
                  <IdentifierValue>{status.id}</IdentifierValue>
                </Td>
                <Td>{status.statusId}</Td>
                <Td>{moment(status.createdAt).format('DD/MM/YYYY HH:mm:ss')}</Td>
              </Tr>
            ))}
        </Tbody>
      </Table>
    </RepositCard>
  );
};
